import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-exit-button',
  templateUrl: './exit-button.component.html',
  styleUrls: ['./exit-button.component.scss'],
})
export class ExitButtonComponent implements OnInit {
  @HostBinding('attr.tabindex') hostTabIndex = -1;
  @Input() exitRouterLink: string | any[] | null = null;
  @Input() exitRouterLinkActive: string | string[] = '';
  @Input() replaceUrl = false;
  @Input() queryParamsHandling: 'merge' | 'preserve' | '' | null = null;

  constructor() { }

  ngOnInit() {}

}
